import { createIcon } from '@/assets/icons/helper.tsx';

export const DocumentSign = createIcon(
  <>
    <path
      d="M7.19971 3.9998C7.19971 3.33706 7.73697 2.7998 8.39968 2.7998H27.5997C28.2625 2.7998 28.7997 3.33706 28.7997 3.9998V30.7998C28.7997 31.4625 28.2625 31.9998 27.5997 31.9998H8.39968C7.73697 31.9998 7.19971 31.4625 7.19971 30.7998V3.9998Z"
      fill="#C275C2"
    />
    <path
      d="M4.40063 1.2C4.40063 0.537258 4.9379 0 5.60063 0H25.2006C25.8634 0 26.4006 0.537258 26.4006 1.2V28.4C26.4006 29.0627 25.8634 29.6 25.2006 29.6H5.60063C4.9379 29.6 4.40063 29.0627 4.40063 28.4V1.2Z"
      fill="#EED8EE"
    />
    <path
      d="M7.99954 5.7998H22.7995C23.1309 5.7998 23.3995 6.06844 23.3995 6.3998C23.3995 6.73117 23.1309 6.9998 22.7995 6.9998H7.99954C7.66817 6.9998 7.39954 6.73117 7.39954 6.3998C7.39954 6.06844 7.66817 5.7998 7.99954 5.7998Z"
      fill="#C275C2"
    />
    <path
      d="M7.99954 9.40039H22.7995C23.1309 9.40039 23.3995 9.66903 23.3995 10.0004C23.3995 10.3318 23.1309 10.6004 22.7995 10.6004H7.99954C7.66817 10.6004 7.39954 10.3318 7.39954 10.0004C7.39954 9.66903 7.66817 9.40039 7.99954 9.40039Z"
      fill="#C275C2"
    />
    <path
      d="M8.00029 13H15.2003C15.5317 13 15.8003 13.2686 15.8003 13.6C15.8003 13.9314 15.5317 14.2 15.2003 14.2H8.00029C7.66889 14.2 7.40027 13.9314 7.40027 13.6C7.40027 13.2686 7.66889 13 8.00029 13Z"
      fill="#C275C2"
    />
    <path
      d="M10.4812 20.0999C10.6471 19.8131 11.0143 19.7145 11.3011 19.8803C11.5701 20.0359 11.6729 20.3683 11.548 20.6455L11.5203 20.7003L11.5195 20.7011C11.5192 20.7015 11.5189 20.7024 11.5183 20.7034C11.5171 20.7055 11.5153 20.7089 11.5128 20.7131C11.5079 20.7216 11.5005 20.7343 11.491 20.7507C11.472 20.7835 11.444 20.8315 11.4086 20.8928C11.3376 21.0155 11.2363 21.1907 11.1148 21.4011C10.8716 21.8217 10.5476 22.383 10.2234 22.9448C9.93219 23.4494 9.64107 23.9543 9.40859 24.3584C9.56275 24.2853 9.73411 24.1996 9.92107 24.103C10.4103 23.8501 10.9897 23.5329 11.5058 23.2874C11.7677 23.1628 12.03 23.0484 12.2757 22.9627C12.5141 22.8796 12.774 22.81 13.0215 22.8018C13.5168 22.7853 14.0527 22.9483 14.6363 23.1854C15.2152 23.4207 15.9205 23.7639 16.78 24.1803C17.5763 24.3603 18.2659 24.3164 18.5367 24.2491C18.7575 24.1922 19.0569 24.1116 19.4887 24.0295C19.8142 23.9676 20.1283 24.1814 20.1902 24.5069C20.252 24.8323 20.0383 25.1466 19.7128 25.2084C19.322 25.2828 19.0582 25.3539 18.8312 25.4123L18.8265 25.4135C18.3331 25.5363 17.4183 25.5673 16.4425 25.3347L16.3792 25.3194L16.3203 25.2909C15.4149 24.8523 14.7324 24.5196 14.1847 24.2971C13.6274 24.0707 13.2896 23.9939 13.0613 24.0015C12.9923 24.0038 12.8658 24.0279 12.6707 24.0959C12.4828 24.1615 12.2643 24.2554 12.0215 24.371C11.5279 24.6057 11.0011 24.8956 10.4723 25.169C9.97651 25.4252 9.44587 25.6855 9.03355 25.785C8.85243 25.8287 8.52747 25.8867 8.23235 25.7311C8.05883 25.6395 7.92889 25.491 7.85934 25.3081C7.79575 25.1407 7.79361 24.9744 7.80855 24.8401L7.82067 24.7749C7.8254 24.7531 7.83019 24.7335 7.83316 24.7237C7.83719 24.7115 7.84447 24.6915 7.84762 24.6835C7.85376 24.6681 7.8593 24.6562 7.86168 24.6511C7.86692 24.6399 7.87151 24.6305 7.8734 24.6268C7.87787 24.6182 7.88239 24.6099 7.88551 24.6042C7.89234 24.5916 7.90141 24.5756 7.91129 24.5581C7.93139 24.5223 7.96003 24.4717 7.99567 24.4092C8.06731 24.2836 8.16955 24.1059 8.29139 23.894C8.53515 23.47 8.85955 22.9068 9.18395 22.3448C9.50835 21.7827 9.83291 21.2215 10.0761 20.8007C10.1977 20.5903 10.299 20.4151 10.3699 20.2924C10.4054 20.2311 10.4333 20.1827 10.4523 20.1499C10.4618 20.1335 10.4689 20.1208 10.4738 20.1123C10.4763 20.1081 10.4784 20.1047 10.4796 20.1026C10.4802 20.1016 10.4809 20.1003 10.4812 20.0999Z"
      fill="url(#documentsign-gradient-1)"
    />
    <path
      d="M22.2813 25.5865L19.4698 21.696L27.8098 15.6692C28.1678 15.4105 28.668 15.4909 28.9267 15.849L30.8011 18.4427C31.0598 18.8008 30.9793 19.3009 30.6212 19.5597L22.2813 25.5865Z"
      fill="url(#documentsign-gradient-2)"
    />
    <path d="M18.6052 25.2806L19.4689 21.6953L22.2803 25.5858L18.6052 25.2806Z" fill="#C275C2" />
    <defs>
      <linearGradient
        id="documentsign-gradient-1"
        x1="19.6007"
        y1="22.8163"
        x2="8.40075"
        y2="22.8163"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DCAFDC" />
        <stop offset="1" stopColor="#C275C2" />
      </linearGradient>
      <linearGradient
        id="documentsign-gradient-2"
        x1="29.5372"
        y1="17.2252"
        x2="21.3954"
        y2="16.7742"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C275C2" />
        <stop offset="1" stopColor="#DCAFDC" />
      </linearGradient>
    </defs>
  </>,
  '0 0 32 32',
  'DocumentSign'
);
